import {useFormContext} from 'react-hook-form';
import React from 'react';
import {Trans} from '@ui/i18n/trans';
import {NormalizedModelField} from '@common/ui/normalized-model/normalized-model-field';
import {Skeleton} from '@ui/skeleton/skeleton';

export interface RequestContentSearchFieldProps {
  titleId?: number | undefined;
  onChange?: (value: number) => void;
}

export function RequestContentSearchField({
  titleId,
  onChange,
}: RequestContentSearchFieldProps) {
  const {watch} = useFormContext();
  const category = watch('category');
  if (!category) return;

  return (
    <NormalizedModelField
      className={'my-24'}
      onChange={(value: string | number) => {
        onChange?.(value as any);
      }}
      disabled={!category}
      defaultValue={titleId}
      label={<Trans message={'Title'} />}
      queryParams={{category: category}}
      endpoint="channel/search-for-addable-content"
    />
  );
}
